<script setup>
import { motion } from "motion-v";

useHead({
  title: "UpBit",
});

// START 버튼 클릭 핸들러
const handleStart = () => {
  // localStorage에 저장
  if (process.client) {
    localStorage.setItem('entered_intro', JSON.stringify({
      timestamp: Date.now(),
      entered: true,
    }));
    
    // 메인 페이지로 이동
    navigateTo('/');
  }
};
</script>
<template>
  <section class="intro">
    <motion.div class="intro__title" :initial="{ opacity: 0, y: -50 }" :animate="{
      opacity: 1,
      y: 0,
      transition: {
        type: 'spring',
        stiffness: 200,
        damping: 20,
        mass: 1,
      },
    }">
      <motion.h1 :initial="{ opacity: 0, scale: 0.8 }" :animate="{
        opacity: 1,
        scale: 1,
        transition: {
          type: 'spring',
          stiffness: 300,
          damping: 15,
          delay: 0.2,
        },
      }">
        BITUP POOL TRADING GAME
      </motion.h1>
      <motion.div class="intro__title-sub" :initial="{ opacity: 0, scale: 0.5, rotate: -5 }" :animate="{
        opacity: 1,
        scale: 1,
        rotate: 0,
        transition: {
          type: 'spring',
          stiffness: 250,
          damping: 12,
          mass: 0.8,
          delay: 0.4,
        },
      }">
        <p>UP OR DOWN <br> PREDICT & WIN</p>
        <motion.i class="intro__title-icon" :initial="{ opacity: 0, scale: 0, rotate: -180 }" :animate="{
          opacity: 1,
          scale: 1,
          rotate: 0,
          transition: {
            type: 'spring',
            stiffness: 200,
            damping: 10,
            delay: 0.8,
          },
        }"></motion.i>
      </motion.div>
    </motion.div>

    <motion.div class="intro__link" :initial="{ opacity: 0, y: 30, scale: 0.8 }" :animate="{
      opacity: 1,
      y: 0,
      scale: 1,
      transition: {
        type: 'spring',
        stiffness: 300,
        damping: 15,
        delay: 1,
      },
    }">
      <button type="button" @click="handleStart">
        BITUP START
      </button>
    </motion.div>

    <div class="intro__thumbs">
      <motion.div class="intro__thumbs-item intro__thumbs-item--up" :initial="{ opacity: 0, x: -100, rotate: -15 }"
        :animate="{
          opacity: 1,
          x: 0,
          rotate: 0,
          transition: {
            type: 'spring',
            stiffness: 150,
            damping: 12,
            delay: 0.6,
          },
        }">
        <picture>
          <source srcset="@/assets/images/intro_up_mo.png" media="(max-width: 992px)">
          <img src="@/assets/images/intro_up.png" alt="">
          </picture>
      </motion.div>
      <motion.div class="intro__thumbs-item intro__thumbs-item--char" :initial="{ opacity: 0, y: 100, scale: 0.5 }"
        :animate="{
          opacity: 1,
          y: 0,
          scale: 1,
          transition: {
            type: 'spring',
            stiffness: 200,
            damping: 15,
            delay: 1,
          },
        }">
        <img src="@/assets/images/intro_char.png" alt="">
      </motion.div>
      <motion.div class="intro__thumbs-item intro__thumbs-item--down" :initial="{ opacity: 0, x: 100, rotate: 15 }"
        :animate="{
          opacity: 1,
          x: 0,
          rotate: 0,
          transition: {
            type: 'spring',
            stiffness: 150,
            damping: 12,
            delay: 0.8,
          },
        }">
        <picture>
          <source srcset="@/assets/images/intro_down_mo.png" media="(max-width: 992px)">
          <img src="@/assets/images/intro_down.png" alt="">
        </picture>
      </motion.div>
    </div>
  </section>
</template>
<style scoped>
@import "@/assets/scss/pages/intro.scss";
</style>